// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.bs.js");

var convertFragment = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__Price__PriceRange(props) {
  var maxPrice = props.maxPrice;
  var minPrice = props.minPrice;
  var draft = use(props.draft);
  var draftProperty = draft.draftProperty;
  var match = draftProperty.propertyType;
  var tmp;
  tmp = match === "FOR_SALE" ? "Lower Price" : "Lower Rent/month";
  var match$1 = draftProperty.propertyType;
  var tmp$1;
  tmp$1 = match$1 === "FOR_SALE" ? "Upper Price" : "Upper Rent/month";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs(CssGrid.Cell, {
                      width: 12,
                      widthMd: 4,
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              labelText: tmp,
                              onChange: (function ($$event) {
                                  minPrice.onChange(Form__Helpers.intFromFormattedPrice($$event));
                                }),
                              onBlur: (function (param) {
                                  minPrice.onBlur();
                                }),
                              onFocus: (function (param) {
                                  minPrice.onFocus();
                                }),
                              status: minPrice.status,
                              prepend: "$",
                              value: Form__Helpers.intOptToFormattedPrice(minPrice.value)
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: minPrice.valid
                            })
                      ]
                    }),
                JsxRuntime.jsxs(CssGrid.Cell, {
                      width: 12,
                      widthMd: 4,
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              labelText: tmp$1,
                              onChange: (function ($$event) {
                                  maxPrice.onChange(Form__Helpers.intFromFormattedPrice($$event));
                                }),
                              onBlur: (function (param) {
                                  maxPrice.onBlur();
                                }),
                              onFocus: (function (param) {
                                  maxPrice.onFocus();
                                }),
                              status: maxPrice.status,
                              prepend: "$",
                              value: Form__Helpers.intOptToFormattedPrice(maxPrice.value)
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: maxPrice.valid
                            })
                      ]
                    })
              ]
            });
}

var Components;

var FormSection;

var TextInputField;

var Cell;

var FormUtils;

var Validators;

var make = PropertyWizardRelay__KeyFacts__Price__PriceRange;

exports.Components = Components;
exports.FormSection = FormSection;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.FormUtils = FormUtils;
exports.Validators = Validators;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* Form__Input Not a pure module */
